import React, { useCallback } from 'react';
import { Notification } from '../Notification';
import { BannerRoot } from './components';
export var BannerItem = function BannerItem(_ref) {
  var _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? [] : _ref$actions,
      _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? false : _ref$icon,
      onDismiss = _ref.onDismiss,
      paragraph = _ref.paragraph,
      heading = _ref.heading,
      variant = _ref.variant;
  var onActionClick = useCallback(function (handleClick) {
    return function () {
      handleClick(onDismiss);
    };
  }, [onDismiss]);
  return /*#__PURE__*/React.createElement(BannerRoot, {
    "data-test": "banner-" + variant,
    variant: variant,
    inverted: true
  }, icon && /*#__PURE__*/React.createElement(Notification.Icon, {
    "data-test": "banner-icon",
    variant: variant,
    icon: icon,
    alignSelf: !paragraph ? 'center' : undefined
  }), /*#__PURE__*/React.createElement(Notification.Content, null, /*#__PURE__*/React.createElement(Notification.Heading, {
    "data-test": "banner-heading"
  }, heading), paragraph && /*#__PURE__*/React.createElement(Notification.Paragraph, {
    "data-test": "banner-paragraph"
  }, paragraph)), actions.length > 0 && /*#__PURE__*/React.createElement(Notification.ButtonGroup, null, actions.map(function (action, actionIdx) {
    return /*#__PURE__*/React.createElement(Notification.Button, {
      key: actionIdx,
      "data-test": "banner-action-" + actionIdx,
      onClick: onActionClick(action.onClick),
      variant: action.variant,
      mode: action.mode
    }, action.children);
  })));
};